import { render } from "./up2_bom_list.vue?vue&type=template&id=0b923888&scoped=true"
import script from "./up2_bom_list.vue?vue&type=script&lang=js"
export * from "./up2_bom_list.vue?vue&type=script&lang=js"

import "./up2_bom_list.vue?vue&type=style&index=0&id=0b923888&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b923888"]])

export default __exports__